function clean(value, max = 240) {
  const text = String(value || "").trim();
  return text ? text.slice(0, max) : null;
}

function bool(value) {
  return value === true;
}

export function normalizeToDoARJourneyContext(input) {
  if (!input || typeof input !== "object") return null;

  const kind = clean(input.kind, 48) || "public_reality";
  if (kind !== "public_reality") return null;

  const slug = clean(input.slug, 160);
  const doarId = clean(input.doarId, 96);
  const revisionId = clean(input.revisionId, 96);
  const title = clean(input.title, 240);
  if (!slug || !doarId || !revisionId || !title) return null;

  return {
    kind,
    sourceSurface: "thedoar",
    slug,
    doarId,
    revisionId,
    title,
    brand: clean(input.brand, 180),
    category: clean(input.category, 120),
    capabilities: {
      viewAR: bool(input.capabilities?.viewAR),
      view3d: bool(input.capabilities?.view3d),
      customize: bool(input.capabilities?.customize),
      remix: bool(input.capabilities?.remix),
    },
    rights: {
      usageType: clean(input.rights?.usageType, 80),
      remixAllowed: bool(input.rights?.remixAllowed),
    },
  };
}

export function publicRealityToToDoARContext(reality) {
  if (!reality || typeof reality !== "object") return null;
  return normalizeToDoARJourneyContext({
    kind: "public_reality",
    slug: reality.slug,
    doarId: reality.doarId,
    revisionId: reality.revision?.id,
    title: reality.identity?.title,
    brand: reality.identity?.brand,
    category: reality.identity?.category,
    capabilities: {
      viewAR: reality.capabilities?.experience?.viewAR,
      view3d: reality.capabilities?.experience?.view3d,
      customize: reality.capabilities?.transform?.customize,
      remix: reality.capabilities?.transform?.remix,
    },
    rights: {
      usageType: reality.rights?.usageType,
      remixAllowed: reality.rights?.remixAllowed,
    },
  });
}

export function sameJourneyContext(a, b) {
  const left = normalizeToDoARJourneyContext(a);
  const right = normalizeToDoARJourneyContext(b);
  if (!left || !right) return false;
  return left.slug === right.slug
    && left.doarId === right.doarId
    && left.revisionId === right.revisionId;
}
